import { useState } from 'react';

import { useNavigate, useLocation } from 'react-router-dom';

import { ApplicationRoute } from 'routes/routes.enums';

export const useBurgersMenu = () => {
  const navigator = useNavigate();
  const location = useLocation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const isMenuOpen = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const goTo = (route: ApplicationRoute) => () => {
    handleClose();
    navigator(route);
  };

  return {
    anchorEl: anchorEl,
    isMenuOpen: isMenuOpen,
    handleClick: handleClick,
    handleClose: handleClose,
    goTo: goTo,
    location: location,
  };
};
